import Swiper from "swiper"

document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "how_to_order_active_step"
  const stepItems = document.querySelectorAll(".steps-nav__item")
  const stepContents = document.querySelectorAll(".step-content")
  const heroElement = document.querySelector(".hero--shorter")
  const stepsNavList = document.querySelector(".steps-nav__list")

  if (!stepItems.length) return

  const originalHeroImage = heroElement
    ? heroElement.style.backgroundImage
    : null
  let isManualChange = false
  let manualChangeTimeout = null

  function isMobile() {
    return window.innerWidth < 992
  }

  function updateHeroImage(stepNumber) {
    if (heroElement) {
      if (isMobile()) {
        const img = document.getElementById("step-image-" + stepNumber)
        if (img) {
          heroElement.style.backgroundImage = `url('${img.src}')`
        }
      } else {
        heroElement.style.backgroundImage = originalHeroImage || ""
      }
    }
  }

  function getStepFromURL() {
    const urlParams = new URLSearchParams(window.location.search)
    const storedStep = localStorage.getItem(STORAGE_KEY)
    if (storedStep) {
      localStorage.removeItem(STORAGE_KEY)
      return parseInt(storedStep)
    }
    const step = parseInt(urlParams.get("step")) || 1
    return step >= 1 && step <= 4 ? step : 1
  }

  function updateURL(step) {
    const url = new URL(window.location)
    url.searchParams.set("step", step)
    window.history.pushState({}, "", url)
  }

  function setManualChange(value) {
    isManualChange = value
    if (manualChangeTimeout) {
      clearTimeout(manualChangeTimeout)
      manualChangeTimeout = null
    }
    if (value) {
      manualChangeTimeout = setTimeout(() => {
        isManualChange = false
        manualChangeTimeout = null
      }, 350)
    }
  }

  function switchToStep(stepNumber, skipSwiper = false, skipUrlUpdate = false) {
    stepItems.forEach((step) => {
      step.classList.remove("steps-nav__item--selected")
      step.classList.add("steps-nav__item--unselected")
    })

    const targetStep = document.querySelector(
      '.steps-nav__item[data-step="' + stepNumber + '"]',
    )
    if (targetStep) {
      targetStep.classList.remove("steps-nav__item--unselected")
      targetStep.classList.add("steps-nav__item--selected")
    }

    stepContents.forEach((content) => {
      content.classList.remove("step-content--active")
      content.classList.add("step-content--hidden")
    })

    const activeContent = document.getElementById("step-" + stepNumber)
    if (activeContent) {
      activeContent.classList.remove("step-content--hidden")
      activeContent.classList.add("step-content--active")
    }

    updateHeroImage(stepNumber)

    if (!skipSwiper && mySwiper && !mySwiper.destroyed) {
      setManualChange(true)
      mySwiper.slideTo(stepNumber - 1, 300)
    }

    if (!skipUrlUpdate) {
      updateURL(stepNumber)
    }
  }

  let mySwiper = null

  function initializeSwiper() {
    if (isMobile()) {
      const initialSlide = getStepFromURL() - 1
      mySwiper = new Swiper(".swiper", {
        slidesPerView: "auto",
        spaceBetween: 0,
        initialSlide: initialSlide,
        slideToClickedSlide: true,
        touchRatio: 1,
        longSwipes: true,
        longSwipesRatio: 0.3,
        threshold: 10,
        on: {
          slideChange: function () {
            if (!isManualChange) {
              const newStep = this.activeIndex + 1
              switchToStep(newStep, true)
            }
          },
          touchEnd: () => {
            if (isManualChange) {
              setManualChange(false)
            }
          },
        },
      })
    }
  }

  // Initialize on page load
  const initialStep = getStepFromURL()
  switchToStep(initialStep, false, false) // Always update URL on initial load
  initializeSwiper()

  // Handle click events on step items
  stepItems.forEach((item) => {
    item.addEventListener("click", function () {
      const stepNumber = parseInt(this.getAttribute("data-step"))
      switchToStep(stepNumber)
    })
  })

  // Handle browser back/forward
  window.addEventListener("popstate", () => {
    const currentStep = getStepFromURL()
    switchToStep(currentStep, false, true) // Skip URL update on popstate
  })

  // Handle window resize
  window.addEventListener("resize", () => {
    const currentStep = getStepFromURL()

    if (!isMobile() && mySwiper && !mySwiper.destroyed) {
      mySwiper.destroy(true, true)
      mySwiper = null
    } else if (isMobile() && (!mySwiper || mySwiper.destroyed)) {
      initializeSwiper()
    }
    updateHeroImage(currentStep)
  })

  // Handle language change links
  const languageLinks = document.querySelectorAll(".lang-nav__item a")
  languageLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const currentStep =
        document
          .querySelector(".steps-nav__item--selected")
          ?.getAttribute("data-step") || "1"
      localStorage.setItem(STORAGE_KEY, currentStep)

      // Update the language link URL to include the current step
      const url = new URL(this.href)
      url.searchParams.set("step", currentStep)
      this.href = url.toString()
    })
  })
})
